import { Segmented } from "antd";
import { Prefix } from "components/GraphTable/Prefix";
import { useCallback, useContext } from "react";

import { FindingsContext } from "../contexts/FindingsContext";

export const FindingsSelect: React.FC<object> = () => {
  const { assignment, setAssignment, state, setState } =
    useContext(FindingsContext);

  const updateAssignmentQuery = useCallback(
    (assignment: string) => setAssignment(assignment),
    [setAssignment]
  );
  const updateStateQuery = useCallback(
    (state: number | string) => setState(String(state)),
    [setState]
  );

  return (
    <Prefix prefix="Findings" textWidth="md" style={{ width: "unset" }}>
      <Segmented
        options={[
          { label: "All", value: "all" },
          { label: "Unassigned", value: "unassigned" },
        ]}
        onChange={updateAssignmentQuery}
        value={assignment}
      />
      <Segmented
        options={[
          { label: "Open", value: "open" },
          { label: "Ignored", value: "ignored" },
          { label: "Resolved", value: "resolved" },
        ]}
        onChange={updateStateQuery}
        value={state}
      />
    </Prefix>
  );
};
